import { VisitTypes } from "../Utility/Constants";
import { apiRequest } from "./ApiUtility";

export async function createNewPlan(authContext, data) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/plan`;

  return await apiRequest("post", url, authContext, data);
}

export async function getPlanById(authContext, id) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/plan/${id}`;

  return await apiRequest("get", url, authContext);
}

export async function getPlans(authContext, filters) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }

  const url = `/api/plan/all`;

  return await apiRequest("post", url, authContext, filters);
}

export async function updatePlanStatus(authContext, appointmentId, newStatus) {
  const url = `/api/appointment/updatestatus/${appointmentId}`;
  const data = {
    newStatus: newStatus,
    facilityId: authContext.auth.selectedFacility.id,
  };

  // Note: Using authContext.auth.authToken as in original code
  const modifiedAuthContext = {
    ...authContext,
    authToken: authContext.auth.authToken,
  };

  return await apiRequest("put", url, modifiedAuthContext, data);
}

export async function updatePlan(authContext, planData) {
  if (!authContext) {
    return { isSuccess: false, data: {} };
  }
  const url = `/api/plan/${planData.id}`;

  return await apiRequest("put", url, authContext, planData);
}

